import React from "react";
import { Col, Row } from "react-bootstrap";
import { ProductReferenceField } from "../../CompoundFields/ProductReferenceField";
import { DescriptionField } from "../../CompoundFields/DescriptionField";
import { FieldGroup } from "../../Groups/FieldGroup";
import { RadioField } from "../../Fields/RadioField";
import { Condition } from "../../Conditionals/Condition";
import { TextareaField } from "../../Fields/TextareaField";
import { pickOne, requiredField } from "../../Validation";

export const Images = () => {
    return <Row>
        <hr/>
        <Col md={ 12 }>
            <h2>Images</h2>
            <ProductReferenceField
                elementType="image"
            />
        </Col>

        <DescriptionField
            parent="Images"
        />

        <Col md={ 12 }>
            <FieldGroup
                groupName="Image Usage"
                groupId="Images"
                groupLabel="How will the image be used?"
                validator={ pickOne }
            >
                {/* WEB (form closes) */ }
                <RadioField
                    fieldId="Image Usage"
                    fieldLabel="Web"
                    fieldValue="Web"
                />

                {/* PRESENTATION (form closes) */ }
                <RadioField
                    fieldId="Image Usage"
                    fieldLabel="Presentation"
                    fieldValue="Presentation"
                />

                {/* SOCIAL MEDIA (form closes) */ }
                <RadioField
                    fieldId="Image Usage"
                    fieldLabel="Social media"
                    fieldValue="Social media"
                />

                {/* BOOTH LAYOUT (opens booth layout form) */ }
                <RadioField
                    fieldId="Image Usage"
                    fieldLabel="Booth layout"
                    fieldValue="Booth layout"
                />

                {/* BOOTH LAYOUT (opens roll up form) */ }
                <RadioField
                    fieldId="Image Usage"
                    fieldLabel="Roll up"
                    fieldValue="Roll up"
                />

                {/* ADVERTISEMENT (opens advertisement form) */ }
                <RadioField
                    fieldId="Image Usage"
                    fieldLabel="Advertisement"
                    fieldValue="Advertisement"
                />

                {/* OTHER (form closes) */ }
                <RadioField
                    fieldId="Image Usage"
                    fieldLabel="Other"
                    fieldValue="Other"
                />
            </FieldGroup>
            <Condition when="Image Usage" is="Other">
                <TextareaField
                    fieldId="Other Usage"
                    fieldLabel="Description"
                    fieldRequired={ true }
                    validator={ requiredField }
                />
            </Condition>
        </Col>
    </Row>;
}